
import { NotifyHelper } from "../../../helpers/toast";
import { eDotDangKyNganh2ActionsObj } from "../../action-types/quan-ly-nganh-2/IDotDangKyNganh2Actions";
import { generateActionForKey, generateActions } from "../generateActions";

export const dotDangKyNganh2Actions = {
   ...generateActions(eDotDangKyNganh2ActionsObj, "DOT_DANG_KY_NGANH_2"),
   ...generateActionForKey(eDotDangKyNganh2ActionsObj, "DOT_DANG_KY_NGANH_2", "SAVE_SUCCESS", () => { NotifyHelper.Success("Lưu thành công"); }),
    ...generateActionForKey(eDotDangKyNganh2ActionsObj, "DOT_DANG_KY_NGANH_2", "DELETE_SUCCESS", () => { NotifyHelper.Success("Xóa thành công"); }),
    ...generateActionForKey(eDotDangKyNganh2ActionsObj, "DOT_DANG_KY_NGANH_2", "SAVE_ERROR", (m) => NotifyHelper.Error(m)),
    ...generateActionForKey(eDotDangKyNganh2ActionsObj, "DOT_DANG_KY_NGANH_2", "DELETE_ERROR", (m) => NotifyHelper.Error(m)),
}